import { useMediaQuery } from '@react-hookz/web/esm/useMediaQuery';
import twMerge from 'twMerge';

import Icon from 'molecules/Icon';

import {
  testimonialButtonIconStyles,
  testimonialButtonStyles,
  testimonialSliderNavigationStyles,
} from 'components/TestimonialSlider/TestimonialSlider.styles';

import screens from 'theme/spacing/screens';

import type { ContentfulComponentQuoteSlider, ContentfulComponentTestimonialSlider } from 'graphqlTypes';
import type { SectionProps } from 'molecules/Section';
import type { FC } from 'react';

export type TestimonialSliderProps = ContentfulComponentQuoteSlider & SectionProps;

interface TestimonialSliderControlsProps {
  cards: ContentfulComponentTestimonialSlider['cards'];
}

const TestimonialSliderControls: FC<TestimonialSliderControlsProps> = ({ cards }) => {
  const isMobile = useMediaQuery(`(min-width: ${screens.xl})`) || false;

  if (!cards) {
    return null;
  }

  const hideNavigation = !isMobile && cards?.length >= 3;

  return (
    <div className="flex w-full items-center justify-between pt-8 sm:pt-12 xl:pt-16">
      <div className={twMerge(testimonialSliderNavigationStyles({ hidden: !hideNavigation }))}>
        <button
          type="button"
          aria-label="Previous Slide"
          className={twMerge(testimonialButtonStyles({ direction: 'prev' }))}
        >
          <Icon icon="arrow-back" size={20} className={twMerge(testimonialButtonIconStyles({ icon: 'prev' }))} />
        </button>
        <button
          type="button"
          aria-label="Next Slide"
          className={twMerge(testimonialButtonStyles({ direction: 'next' }))}
        >
          <Icon icon="arrow-forward" size={20} className={twMerge(testimonialButtonIconStyles({ icon: 'next' }))} />
        </button>
      </div>
      <div className="testimonial-slider-custom-pagination" />
    </div>
  );
};

export default TestimonialSliderControls;
